function parseConfigString(str: string) {
  const el = document.createElement('span');
  el.innerHTML = str;
  return JSON.parse(el.innerText);
}

export const parseConfig = (gustoAC = globalThis.gustoAC) =>
  typeof gustoAC === 'string' ? parseConfigString(gustoAC) : gustoAC;
